import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

function Footer() {
  const currentYear = new Date().getFullYear();

  const handleShare = () => {
    if (navigator.share) {
      navigator.share({
        title: 'ديوان الأرض',
        text: 'المنصة الرقمية المتكاملة لإدارة المزارع وتحسين الإنتاج الزراعي',
        url: window.location.origin,
      })
        .catch((error) => console.log('Error sharing', error));
    } else {
      navigator.clipboard.writeText(window.location.origin);
      alert('تم نسخ رابط المنصة!');
    }
  };

  return (
    <footer className="footer-landing">
      <div className="container-custom footer-container">
        <div className="footer-grid">
          <div className="footer-col about-col">
            <h3 className="footer-logo">ديوان <span className="logo-accent">الأرض</span></h3>
            <p className="footer-description">
              المنصة الرقمية المتكاملة لإدارة المزارع وتحسين الإنتاج الزراعي باستخدام أحدث التقنيات.
            </p>
            <div className="footer-social">
              <a href="https://www.facebook.com/" target="_blank" rel="noopener noreferrer" title="فيسبوك">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">

                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                </svg>
              </a>
              <a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer" title="انستجرام">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.441 1.441 1.441c.795 0 1.439-.645 1.439-1.441s-.644-1.44-1.439-1.44z" />
                </svg>
              </a>
              <a href="https://docs.google.com/forms/d/e/1FAIpQLSfHRdh26_WlS8-67VShpVUtKbvUtC3_sKluUdPc_tTQFsIVOA/viewform?usp=header" target="_blank" rel="noopener noreferrer" title="شاركنا رأيك">
                <span className="material-symbols-outlined">rate_review</span>
              </a>
              <button onClick={handleShare} className="share-footer-btn" title="مشاركة الرابط" style={{ background: 'transparent', border: 'none', color: 'inherit', cursor: 'pointer', padding: 0, display: 'flex' }}>
                <span className="material-symbols-outlined">share</span>
              </button>
            </div>
          </div>

          <div className="footer-col links-col">
            <h4 className="footer-heading">روابط سريعة</h4>
            <ul className="footer-links">
              <li><Link to="/">الرئيسية</Link></li>
              <li><Link to="/features">المميزات</Link></li>
              <li><Link to="/pricing">الأسعار</Link></li>
              <li><Link to="/about">عن المنصة</Link></li>
              <li><Link to="/contact">اتصل بنا</Link></li>
            </ul>
          </div>

          <div className="footer-col services-col">
            <h4 className="footer-heading">خدماتنا</h4>
            <ul className="footer-links">
              <li><Link to="/register">الاستعراض العام</Link></li>
              <li><Link to="/features">مميزات النظام</Link></li>
              <li><Link to="/pricing">باقات الاشتراك</Link></li>
            </ul>
          </div>

          <div className="footer-col contact-col">
            <h4 className="footer-heading">تواصل معنا</h4>
            <ul className="footer-contact-info">
              <li><span className="material-symbols-outlined">location_on</span>اجا - الدقهلية - مصر</li>
              <li><span className="material-symbols-outlined">call</span> <span style={{ direction: 'ltr', display: 'inline-block' }}>+20 10 1698 1295</span></li>
              <li><span className="material-symbols-outlined">mail</span> info@diwanalard.com</li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p >
            حالياً في مرحلة التطوير، ترقبوا المزيد من الميزات قريباً!
            <br />
            © {currentYear} <strong>ديوان الأرض</strong>. كل الحقوق محفوظة.
            <br />
            برمجة وتصميم: <strong>محمد سلامة</strong> |
            فكرة ومحتوى ومسؤول عن التطوير والإدارة الرقمية: <strong>عبدالله جابر</strong> و <strong>محمد سلامة</strong>
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
